export const BRAND_DISPLAY_NAME = 'Keystone AI';
export const BRAND_OWNER = 'Keystone AI team';


export const BRAND_TAGLINE = 'Home design, made understandable';

export const CONTACT_EMAIL = 'aikeystone559@gmail.com';

export const LEGAL_UPDATED_AT = 'March 14, 2026';

export const STUDIO_UNLOCK_KEY = 'keystone_unlock';

export const STUDIO_SESSION_KEY = 'keystone_studio_session';

export const DEFAULT_VISIBLE_LINE_ITEMS = 6;

export const DEFAULT_VISIBLE_ASSEMBLIES = 6;

export const DEFAULT_VISIBLE_NOTES = 2;
